var io = require('../io');
module.exports = function (inOpts) {
    inOpts.url = io.b2bCgiUrl;
    inOpts.cmd = 'index/productRecommendList';
    io.ajax(inOpts);
};


//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/index/getProductList.js
// module id = 164
// module chunks = 6 34